<template>
	<action-card
		v-if="tickets.length"
		:title="$t('nav.requests')"
		icon="ticket"
		:count="tickets.length"
		@open="$router.push('/requests')"
	>
		<button
			v-for="ticket in visibleTickets"
			:key="ticket.id"
			type="button"
			class="portal-action-row"
			@click="$router.push(`/requests/${ticket.id}`)"
		>
			<span class="action-row-copy">
				<strong>{{ ticket.subject }}</strong>
				<small>#{{ ticket.ticketNumber }}<template v-if="ticket.status"> · <span class="ticket-status-dot" :style="{ background: ticketStatusHex(ticket, ticketTypes) || 'var(--v-accent-base)' }"></span>{{ ticket.status }}</template></small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';
	import TicketService from '@/modules/tickets/TicketService';
	import { ticketStatusHex } from '@/modules/tickets/ticketStatus';

	export default {
		name: 'Tickets',

		components: { ActionCard },

		props: {
			tickets: { type: Array, required: true },
		},

		data() {
			return { ticketTypes: [] };
		},

		mounted() {
			new TicketService().getTicketTypes().then((response) => {
				this.ticketTypes = response.data || [];
			}).catch(() => {});
		},

		methods: { ticketStatusHex },

		computed: {
			visibleTickets() {
				return this.tickets.slice(0, 5);
			},
		},
	};
</script>

<style scoped>
	.ticket-status-dot {
		display: inline-block;
		width: 8px;
		height: 8px;
		margin-right: 4px;
		border-radius: 50%;
	}
</style>
